import { isFinite as lodashIsFinite } from "lodash";
import { isNil } from "./type-guards/nil";

export function isPositiveInt(n: null | undefined): false;
export function isPositiveInt(n: string): boolean;
export function isPositiveInt(n: number): n is number;
export function isPositiveInt(n: string | number | null | undefined): boolean {
  if (isNil(n)) return false;
  const num = Number(n);
  return lodashIsFinite(num) && Number.isInteger(num) && num > 0;
}
